import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationLineChartIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "rect",
    {
      x: "64",
      y: "888",
      width: "896",
      height: "72",
      rx: "32",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M641.879 222.842C657.157 210.672 679.352 212.905 691.9 227.874L924.089 504.874C936.862 520.111 934.863 542.817 919.626 555.589C904.389 568.362 881.683 566.364 868.911 551.126L659.277 301.036L150.431 706.395C134.88 718.783 112.231 716.219 99.8423 700.668C87.454 685.117 90.0179 662.468 105.569 650.08L641.879 222.842Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M398.867 141.507C386.545 126.109 364.128 123.491 348.589 135.636L105.831 325.373C90.1656 337.617 87.392 360.241 99.6357 375.907C111.879 391.572 134.504 394.345 150.169 382.102L364.887 214.28L625.133 539.493C637.48 554.922 659.955 557.514 675.49 545.302L918.249 354.461C933.879 342.173 936.589 319.541 924.302 303.91C912.014 288.28 889.382 285.57 873.751 297.858L659.05 466.641L398.867 141.507Z",
      fill: "#0A3A83"
    }
  )
] });
export {
  VisualisationLineChartIcon
};
